import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EuiSelectComponent } from './eui-select.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        EuiSelectComponent,
    ],
    exports: [
        EuiSelectComponent,
    ],
})
export class EuiSelectModule { }
